import React, { useState } from 'react';
import Form from 'screens/shared/form';
import { _t } from 'utils';

export default ({ servers }) => {
  const [filters, setFilters] = useState({
    ramRange: [0, 100],
    coreRange: [0, 100],
    // status: '',
    // managedBy: '',
    searchText: '',
  });

  const {
    ramRange = [],
    coreRange = [],
    // status = '',
    // managedBy = '',
    searchText = '',
  } = filters;

  const applyFilters = () => {
    let filteredServers = servers;
    filteredServers = filteredServers
      .filter((server) => (
        ((server.properties.ram / 1024) >= ramRange[0]
          && (server.properties.ram / 1024) <= ramRange[1])
        && (server.properties.cores >= coreRange[0]
          && server.properties.cores <= coreRange[1])
      ));

    // if (managedBy) {
    //   filteredServers = filteredServers
    //     .filter((server) => (
    //       managedBy === 'Kubernetes'
    //         ? server.metadata.createdBy === '[UNKNOWN]'
    //         : server.metadata.createdBy !== '[UNKNOWN]'));
    // }

    if (searchText) {
      filteredServers = filteredServers
        .filter((server) => (
          server.properties.name.toLowerCase()
            .indexOf(searchText.toLowerCase()) !== -1));
    }

    return filteredServers;
  };

  const setFilter = (values) => {
    setFilters((s) => ({ ...s, ...values }));
  };

  const fields = [
    {
      name: 'searchText',
      onChange: (value) => setFilter({ searchText: value }),
      title: _t('Search'),
      type: 'text',
    },
    {
      name: 'ramRange',
      onChange: (value) => setFilter({ ramRange: value }),
      title: _t('RAM'),
      type: 'range',
      range: [0, 100],
    },
    {
      name: 'coreRange',
      onChange: (value) => setFilter({ coreRange: value }),
      title: _t('Cores'),
      type: 'range',
      range: [0, 100],
    },
    // {
    //   name: 'status',
    //   onChange: (value) => setFilter({ status: value }),
    //   title: _t('Status'),
    //   type: 'dropdown',
    //   options: [['RUNNING']],
    // },
    // {
    //   name: 'managedBy',
    //   onChange: (value) => setFilter({ managedBy: value }),
    //   title: _t('Managed By'),
    //   type: 'dropdown',
    //   options: [['Manually'], ['Kubernetes']],
    // },
  ];

  return ([
    applyFilters(),
    <Form fields={fields} fieldsValues={filters} isActionButtons={false} />,
  ]);
};
